import * as React from "react";
import { Nav, } from 'office-ui-fabric-react/lib/Nav'
import { NavigationResponse } from "../common/model/NavNode";
import { getLinks, GetSelected } from "./helper";
import { useState } from "react";


export function MobileNav(props: NavigationResponse) {
        const [, reRender] = useState(0)
        React.useEffect(() => {
                window.onresize = () => {
                        reRender(new Date().getTime());
                };
        }, []);
        if (props.QuickLaunchNodes && props.QuickLaunchNodes.length > 0) {
                const topLinkGroup = [{
                        links: props.TopNodes.map((n, i) => getLinks(n))
                }];
                const siteLinkGroup = [{
                        links: props.QuickLaunchNodes.map((n, i) => getLinks(n))
                }];
                const selectedSite = GetSelected(props.QuickLaunchNodes);
                const selectedTop = GetSelected(props.TopNodes);
                return (<div>
                        <h3>Globale Navigation</h3>
                        <Nav

                                className="kofiNav mobileSideNav"
                                groups={topLinkGroup}
                                selectedKey={selectedTop}
                        />
                        {props.QuickLaunchNodes.length > 0 ? (<h3>Seitennavigation</h3>) : null}
                        <Nav
                                className="kofiNav mobileSideNav"
                                groups={siteLinkGroup}
                                selectedKey={selectedSite}
                        />
                </div>);
        } else {
                const topLinkGroup = [{
                        links: props.TopNodes.map((n, i) => getLinks(n))
                }];
                const selectedTop = GetSelected(props.TopNodes);
                return (<div>
                        <div className="sideNavSpacer"></div>
                        <Nav
                                className="kofiNav mobileSideNav"
                                groups={topLinkGroup}
                                selectedKey={selectedTop}
                        />
                </div>)
        }
}